export default {
  // ========== Common actions ==========
  add: 'Add',
  apply: 'Apply',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  saving: 'Saving...',
  create: 'Create',
  cancel: 'Cancel',
  close: 'Close',
  closeEntity: 'Close {entity}',
  open: 'Open',
  openEntity: 'Open {entity}',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  import: 'Import',
  select: 'Select',
  copy: 'Copy',
  goTo: 'Go to',
  show: 'Show',
  view: 'View',
  hide: 'Hide',
  modify: 'Modify',
  download: 'Download',
  and: 'and',
  accept: 'Accept',
  continue: 'Continue',
  complete: 'Complete',
  contact: 'Contact',

  // ========== Common tooltips ==========
  addTooltip: 'Add {entity}',
  createTooltip: 'Create {entity}',
  editTooltip: 'Edit {entity}',
  modifyTooltip: 'Modify {entity}',
  deleteTooltip: 'Delete {entity}',
  saveTooltip: 'Save {entity}',
  viewTooltip: 'View {entity}',
  viewDetails: 'View Details',
  copyTooltip: 'Copy {entity}',
  updateTooltip: 'Update {entity}',
  goToTooltip: 'Go to {entity}',
  publishTooltip: 'Publish {entity}',
  replicateTooltip: 'Replicate {entity}',
  showTooltip: 'Show {entity}',

  // ========== Modal titles ==========
  editModalTitle: 'Edit {entity}',
  editDescription: 'Edit Description',
  createModalTitle: 'Create {entity}',
  viewModalTitle: 'View {entity}',
  deleteModalTitle: 'Delete {entity}',
  copyModalTitle: 'Copy of {entity}',

  // ========== Delete confirmations ==========
  deleteConfirmTitle: 'Are you sure you want to delete this instance of "{entity}"?',
  deleteConfirmTitle2: 'Are you sure you want to delete the {entity}?',
  deleteConfirm: 'Are you sure you want to delete?',
  deleteConfirmText: 'This action cannot be undone!',
  toBeDeleted: 'to be deleted',

  // ========== Confirmation messages ==========
  sureToApplyChanges: 'Are you sure you want to apply the changes?',

  // ========== Success messages ==========
  created: 'created.',
  updated: 'updated.',
  deleted: 'deleted.',
  deletedSuccessfully: '{entity} deleted.',
  deletedSuccessfully2: 'The {entity} has been deleted.',
  saved: 'saved.',

  // ========== Common validations ==========
  required: 'This field is required',
  optionalField: 'This field is optional',
  requiredMinLength: 'This field is required and must have at least {min} characters.',
  minLength: 'This field must have at least {min} characters.',
  maxLength: 'This field cannot have more than {max} characters.',
  numeric: 'This field must be numeric.',
  greaterThanZero: 'This field must be greater than 0',
  notBeLessThanZero: 'This field must not be less than 0.',
  greaterThanOrEqualToZero: 'This field must be greater or equal than 0.',
  requiredAndGreaterThanZero: 'This field is required and must be greater than 0.',
  integerGreaterThanZero: 'This field must be an integer greater than zero.',
  numericAndGreaterThanZero: 'This field must be numeric and greater than 0',
  email: 'You must enter a valid email address.',
  hoursAvailable: 'Available hours',
  mustEnterHourGreaterOrEqualZero: 'You must enter an hour greater than or equal to 0',
  cannotExceedHours: 'and cannot exceed {hours} hours.',
  mustEnterScoreGreaterThanZero: 'You must enter a score greater than 0.',
  mustSelectedAtLeast: 'You must select at least {min} {entity}',

  // ========== Selectors ==========
  selectOption: 'Select a {entity}',
  selectOneOrMany: 'Select one or more {entity}',
  selectOneOrManyOnly: 'Select one or more',
  selectOneOrManyFeminine: 'Select one or more {entity}',
  mustSelect: 'You must select {entity}.',
  noOptions: 'No results found for:',
  noCreated: 'There are no {entity} created',
  thisNoCreated: 'This {entity1} does not have any {entity2} created',

  // ========== Table/Grid ==========
  order: 'Order',
  numberAbbreviation: 'No.',
  name: 'Name',
  rut: 'Rut', // Este campo hay que modificarlo, ya que se muestra el tipo de documento en este caso rut pero a futuro deberia haber otro
  description: 'Description',
  user: 'User',
  identifier: 'Identifier',
  email2: 'Email',
  role: 'Role',
  address: 'Address',
  cohort: 'Cohort',
  actions: 'Actions',
  start: 'Start',
  end: 'End',
  date: 'Date',
  startDate: 'Start Date',
  endDate: 'End Date',
  color: 'Color',
  credit: 'Credit',
  noData: 'No data available',
  loading: 'Loading...',
  loadingLongProcess: 'This process may take a few minutes. Please wait.',
  searchPlaceholder: 'Search...',
  clear: 'Clear',
  pressEnterToAddFilter: 'Press Enter To Add a Filter',
  removeFilter: 'Remove Filter',
  displayColumns: 'Display columns',
  filterBy: 'Filter by',
  deselectAllToFilter: 'Deselect all to filter by all table information.',
  noDataToShow: 'No data to show.',
  noDataContextToShow: 'There are no {entity} to show.',
  noMatchingData: 'No data matching your search.',
  showing: 'Showing',
  of: 'of',
  rowsTotal: 'rows in total.',
  perPage: 'Per page:',
  perPageTooltip: 'Number of items to display per page.',
  selectLabel: 'Select',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  selected: 'Selected',
  removeSelected: 'Remove selected',
  clearSelected: 'Clear selected',
  addSelected: 'Add selected',
  available: 'Available',
  assigned: 'Assigned',
  addUser: 'Add user',
  showAll: 'Show all',
  hideAll: 'Hide all',
  common: 'Common',
  code: 'Code',
  isInstitutional: 'Is institutional',

  // ========== General messages ==========
  success: 'Success',
  error: 'Error',
  errorOccurred: 'An error occurred...',
  warning: 'Warning',
  info: 'Information',
  noDataFound: 'No',
  optional: 'Optional',
  yes: 'Yes',
  no: 'No',
  without: 'Without',
  withoutEntity: 'Without {entity}',
  with: 'With',
  withEntity: 'With {entity}',
  notApplicable: 'N/A', // Not applicable
  showMore: 'Click to see more',
  showLess: 'Click to see less',
  seeMore: 'See more',
  seeLess: 'See less',
  title: 'Title',

  // ========== Saving information ==========
  savingInfo: 'Saving information...',
  savingInfoText: 'Please wait a moment.',
  creatingInfo: 'Creating...',
  creatingInfoText: 'Please wait a moment.',
  updatingInfo: 'Updating...',
  updatingInfoText: 'Please wait a moment.',

  // ========== File messages ==========
  generatingExcel: 'Generating Excel...',
  pleaseWaitFile: 'Please wait while the file is being generated.',
  pleaseWait: 'Please wait while it loads.',
  downloadError: 'Could not download the file.',
  generateError: 'Could not generate the file.',
  problemGenerating: 'There was a problem generating the file.',
  file: 'File',
  attachedFile: 'Attached file',
  fileDeleted: 'File deleted.',
  sureDeleteAttachedFile: 'Are you sure you want to delete the attached file?',

  edited: 'Edited',

  // ========== Time ==========
  remainingTime: 'Remaining Time',
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',

  // ========== Language ==========
  matterLanguageAutoChanged: 'The language was changed automatically because this subject was defined in this language.',
}
